<template>
  <div id="search-result-table" class="md-layout">
    <div class="md-layout-item">
      <md-card id="data-table">
        <div class="header-table">
          <md-card-header id="header__md-card-header" class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>list_alt</md-icon>
            </div>
            <h4 class="title inlineTitle">
              {{ title }}
            </h4>
          </md-card-header>
          <div class="header-buttons">
            <div class='header-buttons__input-selects'>
              <!-- search text -->
              <v-text-field class='input__search-text'
                :placeholder="$t('table.enterWordOrPhraseForTheSearch')"
                hide-details
                filled
                dense
                :value='search'
                @input='updateSearch'
              />
              <slot name='title-left'/>
              <md-field class='select__chart-label-search'>
                <v-select
                  hide-details
                  filled
                  dense
                  clearable
                  multiple
                  v-model='menuValueData'
                  :items='chartLabels'
                  />
              </md-field>
              <!-- Yes or No -->
              <md-field class='select__yes-or-no'>
                <v-select
                  hide-details
                  filled
                  dense
                  clearable
                  multiple
                  item-value="value"
                  item-text="text"
                  v-model='selectedAnswer'
                  :items='searchLabels'
                >
                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @mousedown.prevent
                      @click="toggleAnswer"
                    >
                      <v-list-item-action>
                        <v-icon color="primary">
                          {{ selectedAnswer.length === searchLabels.length ? 'fas fa-check-square' : 'far fa-square' }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{$t('search.all')}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </md-field>
            </div>

            <div class='header-buttons__buttons'>
              <!-- XLS -->
              <md-button
                  class="margin-top md-sm md-facebook button__pdf"
                  @click='generateFile("xls")'
                  :disabled='loadingGeneration.xls || dialogsGeneration'
                  v-if="isSefMg"
              >
                <template v-if='!loadingGeneration.xls'>
                  <XLSIcon class="icon-size"/>
                  <md-tooltip md-direction="bottom">
                    {{$t('dataTable.exportXLS')}}
                  </md-tooltip>
                </template>
                <template v-else>
                  <v-progress-circular
                      size='24'
                      width='2'
                      style='transition: 0.1s; height: 33px;'
                      color='#fff'
                      indeterminate
                  />
                </template>
              </md-button>
              <!-- XLS -->
              <md-button
                  class="margin-top md-sm md-facebook button__csv"
                  @click='generateFile("xlsx")'
                  v-if="isSefMg"
                  :disabled='loadingGeneration.xlsx || dialogsGeneration'
              >
                <template v-if='!loadingGeneration.xlsx'>
                  <XLSXIcon class="icon-size"/>
                  <md-tooltip md-direction="bottom">
                    {{$t('dataTable.exportXLSX')}}
                  </md-tooltip>
                </template>
                <template v-else>
                  <v-progress-circular
                      size='24'
                      width='2'
                      style='transition: 0.1s; height: 33px;'
                      color='#fff'
                      indeterminate
                  />
                </template>
              </md-button>

              <!-- PDF -->
              <md-button
                :class="isSefMg ? 'margin-top md-sm md-facebook button__csv' : 'margin-top md-sm md-facebook button__pdf'"
                @click='generateFile("pdf")'
                :disabled='loadingGeneration.pdf || dialogsGeneration'
              >
                <template v-if='!loadingGeneration.pdf'>
                  <md-icon> picture_as_pdf </md-icon>
                  <md-tooltip md-direction="bottom">
                    {{$t('table.exportPdf')}}
                  </md-tooltip>
                </template>
                <template v-else>
                  <v-progress-circular
                    size='24'
                    width='2'
                    style='transition: 0.1s; height: 33px;'
                    color='#fff'
                    indeterminate
                  />
                </template>
              </md-button>
              <!-- CSV -->
              <md-button
                class="margin-left margin-top md-sm md-facebook button__csv"
                @click='generateFile("csv")'
                :disabled='loadingGeneration.csv || dialogsGeneration'
              >
                <template v-if='!loadingGeneration.csv'>
                  <md-icon> table_view </md-icon>
                  <md-tooltip md-direction="bottom">
                    {{$t('table.generateSpreadsheet')}}
                  </md-tooltip>
                </template>
                <template v-else>
                  <v-progress-circular
                    size='24'
                    width='2'
                    style='transition: 0.1s; height: 33px;'
                    color='#fff'
                    indeterminate
                  />
                </template>
              </md-button>
              <!-- Print -->
              <md-button
                class="margin-left margin-top md-sm md-facebook button__print"
                @click='generateFile("print")'
                :disabled='loadingGeneration.print || dialogsGeneration'
              >
                <template v-if='!loadingGeneration.print'>
                  <md-icon> print </md-icon>
                  <md-tooltip md-direction="bottom">
                    {{$t('table.printOut')}}
                  </md-tooltip>
                </template>
                <template v-else>
                  <v-progress-circular
                    size='24'
                    width='2'
                    style='transition: 0.1s; height: 33px;'
                    color='#fff'
                    indeterminate
                  />
                </template>
              </md-button>
              <!-- Close button -->
              <button
                class="button__close-table sm-button"
                @click='closeSearchTable()'
              >
                <md-icon style='color: #fff;'> close </md-icon>
                <md-tooltip md-direction="bottom">
                  Fechar a Tabela de Resultaso de Busca
                </md-tooltip>
              </button>
            </div>
          </div>
        </div>
        <VueJsonToCsv
          id="csv-component"
          :json-data='csvData'
          :csv-title="csvName"
          :labels='formatedCVSLabels'
          style='opacity: 0; pointer-events: none; height: 0px;'
        />
        <md-card-content>
          <md-progress-bar
            :class='{ invisible: !delayedLoading }'
            md-mode='query'
            style='margin-bottom: 0px;'
          />
          <md-table
            class="paginated-table table-striped table-hover"
            id='chatList'
            v-model='data'
            :md-sort='currentSort'
            @update:mdSort='$emit("update:currentSort", $event)'
            :md-sort-order='currentSortOrder'
            @update:mdSortOrder='$emit("update:currentSortOrder", $event)'
            :md-sort-fn='customSort'
            :md-selected-value.sync='selected'
            @update:mdSelectedValue='$emit("selected-items", $event)'
          >
            <md-table-toolbar v-if='!customHeader'>
              <md-field>
                <label for='pages'>
                  {{ $t("commonPhrases.perPage") }}
                </label>
                <md-select v-model='pagination.perPage' name='pages'>
                  <md-option
                    v-for='item in pagination.perPageOptions'
                    :key='item'
                    :label='item'
                    :value='item'
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  class="mb-3"
                  type='search'
                  clearable
                  style='width: 200px;'
                  :placeholder='$t("commonWords.search") + "..."'
                  :value='search'
                  @input='updateSearch'
                />
              </md-field>
            </md-table-toolbar>

            <template v-else>
              <slot name='custom-header' :pagination='pagination'/>
            </template>

            <md-table-toolbar
              v-if='selectable'
              slot='md-table-alternate-header'
              slot-scope='{ count }'
              style='position: relative;'
            >
              <div class="backgroundRed md-toolbar">
                <div class="md-toolbar-section-start">
                  {{ count }}
                  {{ count > 1 ? $t("commonWords.itemsSelected") : $t("commonWords.itemSelected") }}
                </div>

                <div class="md-toolbar-section-end" v-if='selectable'>
                  <div v-if='!allowDeleteSelected'>
                    <slot name='deleteSelectedMessage'/>
                  </div>

                  <md-button
                    class="md-simple.md-github"
                    :disabled='isReadOnly || !allowDeleteSelected'
                    @click='$emit("delete-selected", selected)'
                  >
                    <md-icon>delete</md-icon>
                      {{ $t("commonWords.delete") }}
                  </md-button>

                  <md-button
                    class="md-simple md-github"
                    @click='clearSelection'
                  >
                    {{ $t("commonWords.cancel") }}
                  </md-button>
                </div>
              </div>
            </md-table-toolbar>

            <md-table-row
              slot='md-table-row'
              slot-scope='props'
              :md-selectable='selectable ? "multiple" : undefined'
              @click='$emit("click-row", props)'
              style='cursor: pointer;'
              :class='rowClasses(props.item)'
            >
              <slot name='cells' v-bind='props'/>
            </md-table-row>
          </md-table>
        </md-card-content>

        <md-card-actions md-alignment='space-between'>
          <div>
            <p class="card-category">
              {{ $t("commonWords.showingItems", { from: from + 1, to: to, total: total }) }}
            </p>
          </div>
          <slot name='footer' :pagination='pagination'/>
          <pagination
            class="pagination-no-border pagination-success"
            v-model='pagination.currentPage'
            @input='$emit("update:currentPage", pagination.currentPage)'
            :per-page='pagination.perPage'
            :total='total'
          />
        </md-card-actions>
      </md-card>
    </div>

    <!-- this dialog is only shown if there is a long load -->
    <!-- (usually more than 1000 items) -->
    <v-dialog v-model='dialogsGeneration' persistent max-width="400">
      <v-card style='padding: 8px;'>
        <v-card-text style='text-align: center; padding-top: 4px;'>
          <h3>
            {{ slowRequestMessage() }}
          </h3>

          <v-progress-circular
            size='200'
            width='4'
            style='transition: 0.1s'
            color='#9c27b0'
            :value='progress'
            :indeterminate='progress >= 90'
          >
            <b
              v-if='progress !== null'
              style='font-size: 35px;'
            >
              {{ progress + "%" }}
            </b>
          </v-progress-circular>
        </v-card-text>

        <v-card-actions class="mt-2 pb-3 px-4">
          <v-btn
            class="elevation-0"
            :disabled='progress >= 90'
            @click='dialogsGeneration = false'
            text
            color='#FF0000'
          >
            {{$t('table.cancel')}}
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import enumPropValidator from '@/helpers/enumPropValidator'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import debounce from 'lodash.debounce'
import Swal from 'sweetalert2'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import VueJsonToCsv from 'vue-json-to-csv'

import XLSXIcon from '@/assets/img/xlsx-icon.svg'
import XLSIcon from '@/assets/img/xls-icon.svg'
import * as XLSX from 'xlsx'

export default {
  model: {
    prop: 'data'
  },
  props: {
    data: { type: Array, default: Array },
    title: { required: true, type: String },
    isReadOnly: { default: false, type: Boolean },
    selectable: { type: Boolean, default: true },
    currentSort: { type: String },
    currentSortOrder: {
      type: String,
      default: 'asc',
      ...enumPropValidator('md-sort-order', ['asc', 'desc'])
    },
    customSort: { required: false, type: Function },
    customTotal: { required: true, type: Number },
    customHeader: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    rowClasses: { type: Function, default: () => ({}) },
    allowDeleteSelected: { type: Boolean, default: true },
    endpoint: { required: true },
    filter: { required: true },
    labels: { required: true },
    formatLabelFunction: { type: Function, required: true },
    createHeader: { type: Function },
    chartLabels: { type: Array },
    searchProps: { type: String, default: String },
    menuValue: { type: Array },
    answerValue: { type: Array }
  },
  components: {
    Pagination,
    VueJsonToCsv,
    XLSXIcon,
    XLSIcon
  },
  watch: {
    pagination: {
      handler: 'updatePagination',
      deep: true
    },

    loading (value) {
      if (value === false) {
        const vm = this
        setTimeout(() => {
          vm.delayedLoading = value
        }, 500)
      } else {
        this.delayedLoading = value
      }
    }
  },
  mixins: [isTenantMixin],
  computed: {
    menuValueData: {
      get () {
        return this.menuValue
      },
      set (value) {
        this.$emit('update:menuValue', value)
      }
    },
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },

    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },

    total () {
      return this.customTotal ?? (this.data?.length || 0)
    },

    progress () {
      return this.toFixed(this.progressGeneration, 1) * 100
    },
    formatedCVSLabels () {
      let csvObjLabels = {}
      // ['Início', 'Duração', 'Fim']
      // { inicio: {title: 'Início'}, ...}
      this.labels.forEach((label) => {
        csvObjLabels[this.strToSlug(label)] = {
          title: label
        }
      })
      return csvObjLabels
    },
    selectedAnswer: {
      get () {
        return this.answerValue
      },
      set (value) {
        this.$emit('update:answerValue', value)
      }
    }
  },
  data () {
    return {
      search: this.searchProps,
      pagination: [],
      selected: [],
      delayedLoading: false,
      dialogsGeneration: false,
      loadingGeneration: {
        pdf: false,
        csv: false,
        print: false,
        xls: false,
        xlsx: false
      },
      progressGeneration: 0,
      csvData: [],
      csvName: null,
      searchLabels: [
        { text: this.$t('search.yes'), value: 'sim' },
        { text: this.$t('search.no'), value: 'não' }
      ],
      fileType: 'pdf'
    }
  },
  methods: {
    updateSearch: debounce(function (value) {
      this.search = value
      this.$emit('search-query', value)
    }, 400),
    toggleAnswer () {
      this.$nextTick(() => {
        if (this.selectedAnswer.length === this.searchLabels.length) {
          this.$emit('update:answerValue', [])
        } else {
          this.$emit('update:answerValue', this.searchLabels.map(item => item.value))
        }
      })
    },
    closeSearchTable () {
      this.$emit('close-table')
    },
    /* -----------
      Pagination
    -------------- */
    updatePagination (pagination, oldPagination) {
      this.$emit('pagination', pagination, oldPagination)
    },

    clearSelection () {
      this.selected = []
      this.$emit('clear-selection')
    },

    resetPagination () {
      this.pagination = {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50]
      }
    },

    slowRequestMessage () {
      if (this.fileType === 'pdf') {
        return this.$t('dataTable.generatingPdf')
      } else if (this.fileType === 'xlsx') {
        return this.$t('dataTable.generatingXLSX')
      } else if (this.fileType === 'xls') {
        return this.$t('dataTable.generatingXLS')
      } else if (this.fileType === 'csv') {
        return this.$t('dataTable.generatingCSV')
      }
    },

    /* ----------------
      PDFs and files
    ------------------- */
    async generateFile (type) {
      this.fileType = type
      const totalItems = JSON.parse(JSON.stringify(this.customTotal))
      this.progressGeneration = 0

      if (totalItems > 1000) {
        this.dialogsGeneration = true
      }
      this.loadingGeneration[type] = true

      let filterClone = JSON.parse(JSON.stringify(this.filter))
      const perPage = 1000

      if (filterClone.perPage) {
        filterClone.perPage = perPage
      }
      let dataPages

      try {
        const response = await this.$axios.get(this.endpoint, {
          params: filterClone
        })
        dataPages = [...response.data.data]
        const totalPages = response.data.total / perPage

        this.progressGeneration = 0.1
        const unity = 0.9 / parseInt(totalPages)

        for (let i = 1; i < totalPages; i++) {
          if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
          filterClone.page = i
          let subsequentResponse = await this.$axios.get(this.endpoint, {
            params: filterClone
          })
          dataPages = [...dataPages, ...subsequentResponse.data.data]
          this.progressGeneration += unity
        }

        if (type === 'pdf' || type === 'print') {
          let bodyLabels = []
          let labelLine = []

          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
            this.labels.forEach((element, index) => {
              labelLine.push(this.formatLabelFunction(item, index))
            })
            let tmp = document.createElement('DIV')
            tmp.innerHTML = labelLine[2] ? labelLine[2] : ''
            labelLine[2] = tmp.textContent || tmp.innerText || ''
            bodyLabels.push(labelLine)
            labelLine = []
          })
          // eslint-disable-next-line
          const doc = new jsPDF()

          let offSetY = this.createHeader(doc, this.customTotal)

          if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
          doc.autoTable({
            startY: offSetY,
            head: [this.labels],
            body: bodyLabels
          })

          // We check if want only pdf file or print too
          if (type === 'pdf') {
            let timestamp = Date.now()
            doc.save(`${timestamp}_desempenho_por_item_do_menu_principal.pdf`)
          } else if (type === 'print') {
            window.open(doc.output('bloburl'))
          }
        } else if (type === 'csv') {
          let bodyLabels = []
          let lineObject = {}

          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
            this.labels.forEach((element, index) => {
              lineObject[this.strToSlug(element)] = this.formatLabelFunction(item, index)
            })
            let tmp = document.createElement('DIV')
            tmp.innerHTML = lineObject['mensagem'] ? lineObject['mensagem'] : ''
            lineObject['mensagem'] = tmp.textContent || tmp.innerText || ''
            bodyLabels.push(lineObject)
            lineObject = {}
          })

          this.csvData = bodyLabels
          let timestamp = Date.now()
          this.csvName = `${timestamp}_desempenho_por_item_do_menu_principal`

          this.$nextTick(() => {
            document.querySelector('#csv-component').click()
          })
        } else if (type === 'xlsx' || type === 'xls') {
          let bodyLabels = []
          let lineObject = {}
          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
            this.labels.forEach((element, index) => {
              lineObject[this.strToSlug(element)] = this.formatLabelFunction(item, index)
            })
            bodyLabels.push(lineObject)
            lineObject = {}
          })
          let timestamp = Date.now()
          let fileName = `${timestamp}_desempenho_por_item_do_menu_principal`
          let wb = XLSX.utils.book_new()
          let ws = XLSX.utils.json_to_sheet(bodyLabels)
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
          if (type === 'xlsx') {
            XLSX.writeFile(wb, `${fileName}.xlsx`)
          } else if (type === 'xls') { XLSX.writeFile(wb, `${fileName}.xls`, { bookType: 'biff8' }) }
        }
      } catch (error) {
        if (error.message === this.$t('table.canceledByUser')) {
          Swal.fire({
            icon: 'error',
            title: this.$t('table.calledOff')
          })
        } else {
          if (type === 'csv') {
            Swal.fire({
              icon: 'error',
              title: this.$t('localDataTable.errorGeneratingCsv')
            })
          }
          if (type === 'xlsx') {
            Swal.fire({
              icon: 'error',
              title: this.$t('dataTable.errorGeneratingXlsx')
            })
          } else if (type === 'xls') {
            Swal.fire({
              icon: 'error',
              title: this.$t('dataTable.errorGeneratingXlsx')
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: this.$t('dataTable.errorGeneratingPdf')
            })
          }
        }
      } finally {
        this.dialogsGeneration = false
        this.loadingGeneration[type] = false

        setTimeout(() => {
          this.progressGeneration = 0
        }, 100)
      }
    },

    toFixed (value, precision) {
      var power = Math.pow(10, precision || 0)
      return Math.round(value * power) / power
    },

    strToSlug (str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;'
      var to = 'aaaaaeeeeeiiiiooooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    }
  },
  created () {
    this.resetPagination()
  },
  mounted () {
    this.$nextTick(() => {
      const headers = this.$el.querySelectorAll('th .md-table-head-container .md-table-head-label')

      headers.forEach(el => {
        let title = el.textContent
        el.setAttribute('title', title)
      })
    })
  }
}
</script>

<style lang="css">
  .invisible {
    visibility: hidden !important;
  }
  .md-card
    .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
  .md-checkbox.md-checked
    .md-checkbox-container:after {
    border-color: #33b231 !important;
    top: 1px !important;
    left: 6px !important;
  }
  .md-table-cell-container {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .md-table-alternate-header {
    top: 20px !important;
  }
  #chatList
    > .md-content
      > table
        > tbody
          > .md-table-row
            > .md-table-cell
              > .md-table-cell-container {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    display: block;
    -webkit-box-pack: none;
    -ms-flex-pack: none;
    justify-content: none;
  }
  #chatList
    > .md-content
      > table
        > thead
          > tr
            > .md-table-head
              > .md-table-head-container
                > .md-table-head-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: left;
  }
  #chatList
    > .md-content
      > table
        > thead
          > tr
            > .md-table-head:last-child
              > .md-table-head-container
                > .md-table-head-label {
    padding-right: 0px !important;
  }
  #chatList
    > .md-content
      > table
        > tbody
          > .md-table-row
            > .md-table-cell:hover
              > .md-table-cell-container {
    text-overflow: clip;
    white-space: normal;
    word-break: break-all;
  }

  .icon-size{
    width: 24px;
    height: 24px;
    margin:  4.5px 0;
  }

  .md-tooltip {
    height: 22px !important;
    padding: 8px !important;
    position: absolute !important;
    z-index: 9999 !important;
    pointer-events: none !important;
    border-radius: 2px !important;
    border-top-left-radius: 2px !important;
    border-top-right-radius: 2px !important;
    border-bottom-right-radius: 2px !important;
    border-bottom-left-radius: 2px !important;
    transition: 0.15s cubic-bezier(0, 0, 0.2, 1) !important;
    transition-property: opacity, transform !important;
    will-change: opacity, transform, top, left !important;
    font-size: 10px !important;
    line-height: 22px !important;
    text-transform: none !important;
    white-space: nowrap !important;
    min-width: none !important;
    width: 170px !important;
    max-width: 1000px !important;
    height: auto !important;
    line-height: 20px !important;
    text-align: center !important;
    border-radius: 3px !important;
    background-color: rgba(97, 97, 97, 0.9) !important;
    color: white !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    white-space: normal !important;
    box-shadow: none !important;
  }

  .md-tooltip:after {
    opacity: 0;
  }

  #data-table #header
    .margin-top {
    margin-top: 15px;
  }

  #data-table #header
    .margin-left {
    margin-left: 8px;
  }

  .header-table {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-right: 1rem;
  }

  #header__md-card-header {
    min-width: 250px;
    margin-right: 0px;
  }

  .header-buttons__input-selects {
    display: flex;
  }

  .select__chart-label-search
    .v-input .v-input__control
      .v-input__slot
        .v-select__slot
          .v-select__selections,
  .select__yes-or-no
    .v-input .v-input__control
      .v-input__slot
        .v-select__slot
          .v-select__selections {
    flex-wrap: nowrap;
    width: 100%;
  }

  .select__chart-label-search
    .v-input .v-input__control
      .v-input__slot .v-select__slot
        .v-select__selections
          .v-select__selection--comma:nth-child(1),
  .select__yes-or-no
    .v-input .v-input__control
      .v-input__slot .v-select__slot
        .v-select__selections
          .v-select__selection--comma:nth-child(1) {
    width: 16000px !important;
  }

  .input__search-text {
    margin-right: 10px !important;
    width: 404px !important;
    margin-top: 13px !important;
  }

  .select__chart-label-search {
    margin-right: 0px !important;
    width: 10vw !important;
    min-width: 150px !important;
    margin-right: 10px !important;
  }

  .select__yes-or-no {
    width: 6.5vw !important;
    min-width: 106px !important;
  }

  .header-buttons {
    width: calc(100% - 250px);
    flex-direction: column-reverse;
    display: flex;
    align-items: flex-end;
    margin: 10px 0px 0px 0px;
    float: right;
  }

  .header-buttons__buttons {
    display: flex;
    justify-content: flex-end;
  }

  .md-button
    > .md-ripple
      > .md-button-content
        > .md-icon,
  .sm-button
    > .md-icon {
    font-size: 24px !important;
  }

  .button__pdf {
    margin: 0px 10px 8px 0px !important;
    min-width: 80px !important;
    height: 46px !important;
  }

  .button__csv {
    margin: 0px 10px 8px 0px !important;
    min-width: 80px !important;
    height: 46px !important;
  }

  .button__print {
    margin: 0px 10px 8px 0px !important;
    min-width: 80px !important;
    height: 46px !important;
  }

  .button__close-table {
    display:flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    background-color: #F88E51;
    border-radius: 3px;
    box-shadow: 0 2px 2px 0 rgba(59, 89, 152, 0.14),
                0 3px 1px -2px rgba(59, 89, 152, 0.2),
                0 1px 5px 0 rgba(59, 89, 152, 0.12);
    height: 46px;
    width: 50px;
    cursor: pointer;
  }

  .button__close-table:hover {
    box-shadow: 0 14px 26px -12px rgba(59, 89, 152, 0.42),
                0 4px 23px 0px rgba(0, 0, 0, 0.12),
                0 8px 10px -5px rgba(59, 89, 152, 0.2);
  }

  .v-text-field .v-input__icon--clear {
    opacity: 1 !important;
  }
  /* ----------------
      RESPONSIVENESS
  ------------------- */
  @media (max-width: 1110px) {
    .header-buttons__input-selects,
    .header-buttons__buttons {
      margin-right: 1rem;
    }
  }

  @media (min-width: 1180px) {
    .header-buttons {
      flex-direction: row;
      justify-content: flex-end;
    }

    .input__search-text {
      width: calc(-1026px + 100vw) !important;
      max-width: 404px !important;
    }

    .button__pdf {
      margin: 0px 10px 8px 10px !important;
    }
  }
</style>
